import { MediaGallery } from "@components/media/MediaGallery"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Image Carousel",
  conditions: {
    postTypes: ["article", "hall-of-fame"],
  },
  tags: ["root"],
  category: "media",
  icon: "format-gallery",
  flags: {
    fullWidth: true,
    solidBg: true,
  },
}

export default defineBlock("media/carousel", (props) => {
  return (
    <div className="bg-black text-white w-full py-8 relative group overflow-hidden max-w-[100vw] mt-8">
      <MediaGallery
        items={props.images}
        className={{
          viewport: "h-[70vh] md:h-[50vh] w-full",
          track: "h-full",
          slide: "px-8",
          thumbs:
            "absolute left-0 right-0 bottom-0 pb-3 h-6 opacity-0 translate-y-5 group-hover:opacity-100 group-hover:translate-y-0 transition-all delay-[1s] group-hover:delay-0",
        }}
      />
    </div>
  )
})
